// emailModify.js

import request from '@/utils/request';

export function emailModify(data) {
  return request({
    url: '/v1/user_info/modify_email',
    method: 'post',
    data: data,
  });
}

export function emailModifyCode(data) {
  return request({
    url: '/v1/user_info/modify_email_code',
    method: 'post',
    data: data,
  });
}
